export default __webpack_public_path__ + "static/media/video-greetings-digital-sign-in.d2be956b.jpg";